import React from "react";
import {
    Filter,
    Palmtree,
    Presentation,
    Hotel,
    EyeIcon,
    FileText,
    Bus,
    Plane,
} from "lucide-react";
import { Button } from "./ui/button";
const ServiceTypeFilter = ({
    serviceTypeFilter,
    setServiceTypeFilter,
    type,
}) => {
    const serviceTypes = [
        {
            id: "is_holiday_package_required",
            name: "Holiday",
            icon: Palmtree,
            color: "bg-green-100 text-green-700",
        },
        {
            id: "is_mice_required",
            name: "M.I.C.E.",
            icon: Presentation,
            color: "bg-purple-100 text-purple-700",
        },
        {
            id: "is_hotel_booking_required",
            name: "Hotel",
            icon: Hotel,
            color: "bg-blue-100 text-blue-700",
        },
        {
            id: "is_sight_seeing_required",
            name: "Sightseeing",
            icon: EyeIcon,
            color: "bg-yellow-100 text-yellow-700",
        },
        {
            id: "is_visa_required",
            name: "Visa",
            icon: FileText,
            color: "bg-red-100 text-red-700",
        },
        {
            id: "is_transport_within_city_required",
            name: "City Transport",
            icon: Bus,
            color: "bg-indigo-100 text-indigo-700",
        },
        {
            id: "is_transfer_to_destination_required",
            name: "Destination Transport",
            icon: Plane,
            color: "bg-cyan-100 text-cyan-700",
        },
    ];

    return (
        <div className={`${type !== "openRequests" ? "border-t" : ""} pt-4`}>
            <div className="flex flex-wrap items-center gap-3">
                {type !== "openRequests" && (
                    <div className="flex items-center gap-2">
                        <Filter className="w-4 h-4 text-gray-500" />
                        <span className="text-sm font-medium text-gray-700">
                            Filter by Service Type:
                        </span>
                    </div>
                )}
                <Button
                    variant={serviceTypeFilter === "" ? "default" : "outline"}
                    size="sm"
                    onClick={() => setServiceTypeFilter("")}
                    data-testid="filter-service-all"
                >
                    All Services
                </Button>
                {serviceTypes.map((serviceType) => {
                    const Icon = serviceType.icon;
                    return (
                        <Button
                            key={serviceType.id}
                            variant={
                                serviceTypeFilter === serviceType.id
                                    ? "default"
                                    : "outline"
                            }
                            size="sm"
                            onClick={() =>
                                setServiceTypeFilter(
                                    serviceTypeFilter === serviceType.id
                                        ? ""
                                        : serviceType.id,
                                )
                            }
                            data-testid={`filter-service-${serviceType.id}`}
                            className="gap-1"
                        >
                            <Icon className="w-3 h-3" />
                            {serviceType.name}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default ServiceTypeFilter;
